import { Navigate } from 'react-router-dom'
import { isAdmin } from '@/utils/adminAuth'
import { isProfissional } from '@/utils/profissionalAuth'
import { useSessionExpiryWatch } from '@/hooks/useSessionExpiryWatch'

interface RequireStaffAuthProps {
  children: React.ReactNode
}

/** Permite apenas sessão de administrador ou profissional. */
export function RequireStaffAuth({ children }: RequireStaffAuthProps) {
  useSessionExpiryWatch()

  if (isAdmin() || isProfissional()) {
    return <>{children}</>
  }

  return <Navigate to="/" replace />
}
